var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyKeyFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copy_2_",
    "data-name": "copy (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21057",
    "data-name": "Path 21057",
    d: "M15.143,8.714v6.429H8.714V8.714h6.429m0-.714H8.714A.714.714,0,0,0,8,8.714v6.429a.714.714,0,0,0,.714.714h6.429a.714.714,0,0,0,.714-.714V8.714A.714.714,0,0,0,15.143,8Z",
    transform: "translate(-5.857 -5.857)",
    fill: "#203662"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21058",
    "data-name": "Path 21058",
    d: "M2.714,7.714H2v-5A.714.714,0,0,1,2.714,2h5v.714h-5Z",
    transform: "translate(-2 -2)",
    fill: "#203662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyKeyFrame);
export default __webpack_public_path__ + "static/media/CopyKeyFrame.327a67fc3b12718d90496b5412fb41c5.svg";
export { ForwardRef as ReactComponent };